import { useUserGroupsCurrentUserAdminState } from '../../services/user.service';
import { ProjectList } from './ProjectList';
import { ProjectListApprovers } from './ProjectListApprovers';
import { ProjectsSkeleton } from './components/ProjectsSkeleton';
import { NoAccess } from '../../components/NoAccess';

export default function Projects() {
  const { data: user, isLoading } = useUserGroupsCurrentUserAdminState();

  if (isLoading) return <ProjectsSkeleton isLoading={isLoading} />;

  if (!user) {
    return <NoAccess />;
  }

  return user?.role === 'Approver' ? <ProjectListApprovers /> : <ProjectList />;
}
